/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TemplateCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateCellPresenter, _super);
    function TemplateCellPresenter(a, b) {
        var _this = _super.call(this, a) || this;
        _this.d = null;
        _this.d = b;
        return _this;
    }
    Object.defineProperty(TemplateCellPresenter.prototype, "e", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    TemplateCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        var c = this.d.actualColumns._inner[a.k.ax];
        if (a.aw(CellModel.ed) || a.aw(CellModel.f7)) {
            var d = Math.min(1, Math.max(0, a.b6));
            var e = a.bx * (1 - d);
            this.e.b4.element.setRawStyleProperty("opacity", e.toString());
        }
        c.jh(a, this.e.b4);
    };
    TemplateCellPresenter.$t = markType(TemplateCellPresenter, 'TemplateCellPresenter', CellPresenterBase.$);
    return TemplateCellPresenter;
}(CellPresenterBase));
export { TemplateCellPresenter };
//# sourceMappingURL=TemplateCellPresenter.js.map
